import Vue from 'vue'
import fontawesome from '@fortawesome/fontawesome'
import FontAwesomeIcon from '@fortawesome/vue-fontawesome'

import {
  faCommentAlt as farCommentAlt,
  faEye as farEye,
  faSquare as farSquare
} from '@fortawesome/fontawesome-free-regular/shakable.es'

import {
  faAngleDown,
  faAngleLeft,
  faAngleRight,
  faAngleUp,
  faArrowDown,
  faArrowUp,
  faBan,
  faBars,
  faBuilding,
  faBullseye,
  faCertificate,
  faCheck,
  faCog,
  faCommentAlt,
  faComments,
  faDownload,
  faEdit,
  faEnvelope,
  faEye,
  faEyeSlash,
  faFileExcel,
  faFilePdf,
  faFileWord,
  faFolder,
  faHome,
  faInfoCircle,
  faKey,
  faList,
  faLock,
  faMinus,
  faPencilAlt,
  faPhone,
  faPlus,
  faPrint,
  faQuestion,
  faSave,
  faSearch,
  faSignOutAlt,
  faSmile,
  faSquare,
  faStream,
  faTimes,
  faToggleOn,
  faToggleOff,
  faToolbox,
  faTrash,
  faUpload,
  faUser,
  faUserFriends,
  faUsers,
  faUsersCog,
  faUserLock,
  faWrench
} from '@fortawesome/fontawesome-free-solid/shakable.es'

import {
} from '@fortawesome/fontawesome-free-brands/shakable.es'

fontawesome.library.add(
  faAngleDown,
  faAngleLeft,
  faAngleRight,
  faAngleUp,
  faArrowDown,
  faArrowUp,
  faBan,
  faBars,
  faBuilding,
  faBullseye,
  faCertificate,
  faCheck,
  faCog,
  faCommentAlt,
  faComments,
  faDownload,
  faEdit,
  faEnvelope,
  faEye,
  faEyeSlash,
  faFileExcel,
  faFilePdf,
  faFileWord,
  faFolder,
  faHome,
  faInfoCircle,
  faKey,
  faList,
  faLock,
  faMinus,
  faPencilAlt,
  faPhone,
  faPlus,
  faPrint,
  faQuestion,
  faSave,
  faSearch,
  faSignOutAlt,
  faSmile,
  faSquare,
  faStream,
  faTimes,
  faTrash,
  faToggleOn,
  faToggleOff,
  faToolbox,
  faUpload,
  faUser,
  faUserFriends,
  faUsers,
  faUsersCog,
  faUserLock,
  faWrench,

  farCommentAlt,
  farEye,
  farSquare
)

Vue.component('fa', FontAwesomeIcon)



// WEBPACK FOOTER //
// ./resources/js/plugins/fontawesome.js